import '@slightlyoff/lite-vimeo';

// disable controlls on lite-vimeo
document.addEventListener('DOMContentLoaded', function () {
    var contentBlocks = document.querySelectorAll('.content-block');
    if (contentBlocks) {
        // check if any of the contentBlocks children div  has a inline style , if so remove it
            contentBlocks.forEach(function (contentBlock) {
                var divs = contentBlock.querySelectorAll('div');
                if (divs) {
                    divs.forEach(function (div) {
                        if (div.hasAttribute('style')) {
                            div.removeAttribute('style');
                        }
                    });
                }
            }
        );
    }

});
